import * as experiences from '@wix/auto_sdk_table-reservations_experiences';
import * as reservations from '@wix/auto_sdk_table-reservations_reservations';
import * as reservationLocations from '@wix/auto_sdk_table-reservations_reservation-locations';
import * as timeSlots from '@wix/auto_sdk_table-reservations_time-slots';

export { experiences, reservations, reservationLocations, timeSlots };
